import { InputAdornment, LinearProgress, TextField } from '@mui/material';
import { getIn, useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { POST_WITH_ID } from '@brickwise/asset-validation/dist/asset/assetData';
import { InputFieldConditionalRendering } from 'src/components/conditional-rendering/InputFieldConditionalRendering';

interface Props {
  disabled?: boolean;
}

export const AssetOccupancy: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext<POST_WITH_ID>();

  const getValueForProgressbar = (value: number): number => {
    if (isNaN(value)) {
      return 0;
    }

    if (value <= 0) {
      return 0;
    } else if (value > 100) {
      return 0;
    } else {
      return value;
    }
  };

  const occupancyRate = formik.values.rentalDetails?.occupancyRate;
  const isTouched = getIn(formik.touched, 'rentalDetails.occupancyRate');
  const fieldError = getIn(formik.errors, 'rentalDetails.occupancyRate');

  return (
    <InputFieldConditionalRendering fieldName="rentalDetails.occupancyRate">
      <div style={{ marginTop: 10, marginBottom: 10 }}>
        <TextField
          disabled={disabled}
          fullWidth
          label={t('dashboard.assets.addedit.main.occupancy.fields.occupancyrate')}
          margin="normal"
          {...formik.getFieldProps('rentalDetails.occupancyRate')}
          type="number"
          variant="outlined"
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          }}
          value={formik.values.rentalDetails?.occupancyRate}
          onChange={(event) => {
            if (event.target.value === '') {
              formik.setFieldValue('rentalDetails.occupancyRate', '');
            } else {
              formik.setFieldValue('rentalDetails.occupancyRate', parseFloat(event.target.value));
            }
          }}
          error={isTouched && fieldError}
          helperText={fieldError && isTouched ? fieldError : ' '}
        />
        {occupancyRate !== undefined && (
          <LinearProgress
            sx={{ height: 10, borderRadius: 5, marginBottom: 3 }}
            color={occupancyRate <= 7 || occupancyRate > 100 ? 'secondary' : 'success'}
            variant="determinate"
            value={getValueForProgressbar(parseFloat(formik.values.rentalDetails?.occupancyRate as any))}
          />
        )}
      </div>
    </InputFieldConditionalRendering>
  );
};
